import { useEffect, useState } from "react";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";
import { useSlugFlow } from "hooks/useSlugFlow";
import SoftTypography from "components/SoftTypography";
import SoftEditor from "components/SoftEditor";
import { updateFlow } from "api/FlowDesignerApis";
import { useAuth0 } from "@auth0/auth0-react";
import ProtectedButton from "authentication/ProtectedButton";
import { PERMISSIONS } from "constants/portal";
import { htmlHasContent } from "helpers/common";
import { useDetermineShareFlowUserAccessType } from "hooks/useDetermineShareFlowUserAccessType";

export const Overview = () => {
   const [documentation, setDocumentation] = useState("");
   const [isEditing, setIsEditing] = useState(false);
   const { flow } = useSlugFlow();
   const { isReadOnlyAccess } = useDetermineShareFlowUserAccessType(flow?.id);
   const { user } = useAuth0();

   const handleCancelEdit = () => setIsEditing(false);

   const handleEditDocumentation = () => setIsEditing(true);

   const handleSaveDocumentation = async () => {
      const { id, updated_date_time, created_date_time, tenant_id, ...restFlow } = flow;

      const input = {
         ...restFlow,
         documentation
      };

      await updateFlow(user?.stripeId, flow.id, input, true);
      setIsEditing(false);

      if (!htmlHasContent(documentation)) {
         setDocumentation("");
      }
   };

   useEffect(() => {
      if (!flow) return;

      if (flow?.documentation && htmlHasContent(flow.documentation)) {
         setDocumentation(flow.documentation);
      }
   }, [flow]);

   if (!flow) return <></>;

   return (
      <SoftBox className="overview">
         <SoftBox
            sx={{
               marginBottom: "24px",
               padding: "20px 24px 0 0"
            }}
         >
            <ProtectedButton permissionName={PERMISSIONS.EDIT_WORKFLOWS}>
               <SoftButton
                  sx={{
                     display: "block !important",
                     marginLeft: "auto !important"
                  }}
                  variant="outlined"
                  color="info"
                  onClick={handleEditDocumentation}
                  disabled={isReadOnlyAccess}
               >
                  edit
               </SoftButton>
            </ProtectedButton>
         </SoftBox>
         <SoftBox
            className="border-top"
            sx={{
               padding: "32px 12px"
            }}
         >
            {!isEditing && (
               <SoftBox
                  sx={{
                     textAlign: "center",
                     padding: documentation ? 0 : "20px 0 24px"
                  }}
               >
                  {!documentation && <SoftTypography fontSize="16px">Add documentation</SoftTypography>}
                  {documentation && <SoftEditor className="documentation preview" theme="bubble" value={documentation} readOnly />}
               </SoftBox>
            )}
            {isEditing && (
               <SoftBox>
                  <SoftEditor theme="snow" value={documentation} onChange={(value) => setDocumentation(value)} />
                  <SoftBox
                     sx={{
                        paddingTop: "24px",
                        display: "flex",
                        width: "100%",
                        justifyContent: "flex-end",
                        columnGap: "18px"
                     }}
                  >
                     <SoftButton
                        sx={{
                           minWidth: "110px"
                        }}
                        variant="outlined"
                        color="info"
                        onClick={handleCancelEdit}
                     >
                        cancel
                     </SoftButton>
                     <SoftButton
                        sx={{
                           minWidth: "110px"
                        }}
                        variant="gradient"
                        size="medium"
                        color="primary"
                        onClick={handleSaveDocumentation}
                        disabled={!documentation}
                     >
                        save
                     </SoftButton>
                  </SoftBox>
               </SoftBox>
            )}
         </SoftBox>
      </SoftBox>
   );
};
